import { useEffect } from "react";
import { useMe } from "@/data/user.ts";
import { useTranslation } from "react-i18next";
import { availableCredits } from "@/utils/one-to-one.ts";
import cn from "classnames";
import Button from "@edusogno/primitives/button";
import tutorPic from "@/assets/img/tutorPic.png";
import useGlobals from "@/utils/hooks/useGlobals";
import useOneToOne from "@/utils/hooks/useOneToOne.ts";
import InfoOutlineIcon from "@/components/icons/InfoOutlineIcon.tsx";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

const CHECKOUT_BASE = import.meta.env.EDS_CHECKOUT_BASE;

const Recharge = () => {
  const { t } = useTranslation();
  const { me } = useMe();
  const { credits } = useOneToOne();
  const { setGlobalState } = useGlobals();

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-brand-background-light");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <DashboardContentLayout className={"px-4 bg-white overflow-y-scroll"}>
        <div className={"flex flex-col items-start gap-2 pb-2 "}>
          <img src={tutorPic} alt="tutor-pic" className="w-[125px] mr-auto" />

          <div className="flex flex-col w-full">
            <h2 className="text-xl font-semibold  text-secondary font-[Inter]">
              {/* How to get credits? */}
              {t("one_to_one.how_to_get_credits.title")}
            </h2>

            <p className="text-sm font-semibold text-primary">
              {/* Buying 1 credit = 1 hour of lesson */}
              {t("one_to_one.how_to_get_credits.subtitle")}
            </p>
          </div>

          <div className="flex flex-row gap-2 items-center justify-start my-1">
            <InfoOutlineIcon className="fill-brand w-5 h-5" />

            <p className="text-[12px] leading-[100%] font-normal text-brand">
              {/* The more credits you buy, the less they cost! */}
              {t("one_to_one.how_to_get_credits.info")}
            </p>
          </div>

          <div
            className={cn(
              "rounded-md min-h-[42px] w-full bg-lightPrimary border-brand border-solid border-[1px] flex  justify-center items-center",
              { "border-light": credits === 0 },
            )}
          >
            <p className="text-base font text-brand">
              {/* Your credits:&nbsp; */}
              {t("one_to_one.your_credits")}:&nbsp;
              <strong className={cn({ "!text-red-600": credits === 0 })}>
                {credits}
              </strong>
            </p>
          </div>
        </div>

        <div className="flex flex-col h-full justify-between gap-2 items-center">
          <div className="grid grid-cols-1 gap-4 w-full">
            {availableCredits.map((r) => (
              <div
                key={r.label}
                className="flex flex-row w-full items-center px-5 bg-brand-lavender border-[1px] rounded-md border-brand-secondary"
              >
                <div className="px-1  w-full flex flex-row justify-between items-center py-2 gap-2">
                  <p className="text-brand-secondary text-sm font-semibold text-start">
                    {t(r?.label)}
                  </p>

                  <div>
                    <div className="w-full flex justify-center flex-row items-center bg-light rounded px-2 py-1 gap-1">
                      <p className="text-sm font-semibold text-brand">
                        {r?.price}
                      </p>

                      <p className="text-xs">
                        {/* /each */}/{t("one_to_one.how_to_get_credits.each")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex w-full justify-center gap-x-2 mt-10">
            <Button
              size="md"
              onClick={() => {
                window.open(
                  `${CHECKOUT_BASE}one-to-one/${"adRIlqNoTRGL32CwBF9"}/${me
                    ?.item.user.token}/academy?quantity=1`,
                  "_blank",
                );
              }}
            >
              {/* Buy new credits */}
              {t("btns.buy_new_credits")}
            </Button>
          </div>
        </div>
      </DashboardContentLayout>
    </>
  );
};

export default Recharge;
